import "../App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppLayout from "./AppLayout";
import Advisory from "../features/advisory/Advisory";
import Home from "../features/home/Home";
//import menu list
import NAVBARLIST from "../db/navBarMenuList";
import Team from "../features/team/Team";
import News from "../features/news/News";
import Gallery from "../features/gallery/Gallery";
import NamingOpportunity from "../features/documents/NamingOpportunity";
//import components
function App() {
  return (
    <div >
      <BrowserRouter>
        <Routes>
          <Route path = {NAVBARLIST.Home} element = {<AppLayout />}  >
            <Route index element = {<Home />} />
            <Route path={NAVBARLIST.Advisory} element = {<Advisory />} />
            <Route path ={NAVBARLIST.Team} element ={<Team />} />
            <Route path={NAVBARLIST.News} element ={<News />} /> 
            <Route path={NAVBARLIST.Gallery} element ={<Gallery />} />    
            <Route path={NAVBARLIST.Documents} element = {<NamingOpportunity/>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
